import React, { useState } from 'react';
import { ButtonGroup, Col, Form, Row } from 'react-bootstrap';
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import Button from '../../components/Button';

const SlidesOver = () => {
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });

  return (
    <Row className="styles-section" id="slides-over">
      <Col xs={12}>
        <h3>Slides Over</h3>
      </Col>
      <Col xs={12} sm={6}>
        <Button onClick={() => {
          setState({
            isPaneOpen: true
          });
        }}> Open right
        </Button>
        <Button onClick={() => {
          setState({
            isPaneOpenLeft: true
          });
        }}> Open left
        </Button>
      </Col>
      <SlidingPane
        overlayClassName="slide-over"
        isOpen={state.isPaneOpen}
        closeIcon={null}
        width={"500"}
        shouldCloseOnEsc
        onRequestClose={() => {
          setState({ isPaneOpen: false });
        }}
        hideHeader
        from={document.body.dir === 'ltr' ? 'right' : 'left'}
      >
        <Form>
          <h3>
            Edit address
          </h3>
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Control type="text" placeholder="Status" />
          </Form.Group>
          <hr />
          <Form.Group>
            <Form.Label>Country</Form.Label>
            <Form.Control type="text" placeholder="Country" />
          </Form.Group>
          <hr />
          <Form.Group>
            <Form.Label>Address 1</Form.Label>
            <Form.Control type="text" placeholder="Address 1" />
          </Form.Group>
          <Form.Group>
            <Form.Label>Address 2</Form.Label>
            <Form.Control type="text" placeholder="Address 2" />
          </Form.Group>
          <Form.Group>
            <Form.Label>City</Form.Label>
            <Form.Control type="text" placeholder="City" />
          </Form.Group>
          <Form.Group>
            <Form.Label>State</Form.Label>
            <Form.Control type="text" placeholder="State" />
          </Form.Group>
          <Form.Group>
            <Form.Label>Zip code</Form.Label>
            <Form.Control type="text" placeholder="Zip code" />
          </Form.Group>
          <hr />
          <Row className='align-items-end'>
            <Col>
              <ButtonGroup>
                <Button variant="tertiary">Delete</Button>
                <Button variant="secondary">Cancel</Button>
                <Button variant="primary">Save</Button>
              </ButtonGroup>
            </Col>
          </Row>

        </Form>
      </SlidingPane>
      <SlidingPane
        overlayClassName="slide-over"
        isOpen={state.isPaneOpenLeft}
        width={"100%"}
        shouldCloseOnEsc
        onRequestClose={() => {
          setState({ isPaneOpenLeft: false });
        }}
        from={document.body.dir === 'ltr' ? 'right' : 'left'}
      >
        <div>
          My width will be always 100%
        </div>
      </SlidingPane>

    </Row >
  );
};

export default SlidesOver;